export default [
    // {
    //     name: "pepeChain",
    //     techStack: ["React", "BootStrap"],
    //     description: "PepeChain is a new blockchain entirely built and designed to be community-driven",
    //     img: "pepeChain.png",
    //     buttonLink: "https://pepechain.vercel.app/",
    //     githubLink: "https://github.com/Promisemagoga/pepechain.git",

    // },

    {
        name: "Ezamazwe EduTech",
        techStack: ["React", "Material UI","Node.js", "Firebase"],
        description: "My team and I built a learning management system like udemy, but its focus was delivering content on CAPS, IEB, and entrepreneurial skills. This was part of our final project as CodeTribers.",
        img: "Ezamazwe.PNG",
        buttonLink: "https://edutech-app-eecfd.web.app/",
        githubLink: "",

    },

    {
        name: "Hotel Management App",
        techStack: ["React", "BootStrap", "Material UI", "Firebase"],
        description: "Have a home away from home, with our luxury rooms and get to relax a bit. Because firebase has it's own limitation and am avoiding to exceed the quota and also find my website messed up , i won't provide the admin credentials. If you want to explore the client side, please register with dummy data.",
        img: "hotel.png",
        buttonLink: "https://hotel-p9nloji5j-promisemagoga.vercel.app/",
        githubLink: "https://github.com/Promisemagoga/Hotel-Management-App.gits",


    },
    {
        name: "Miss Diamonds Treacts",
        techStack: ["HTML5","CSS3", "JaaScript"],
        description:"Are you around Pretoria? Book yourself and your loved ones a taste of relaxation at MS Diamonds Treat, a spa business located in Ga-Rankua.",
        img: "diamondShot.PNG",
        buttonLink: "https://ms-diamonds-treats.vercel.app/index.html",
        githubLink: "https://github.com/Promisemagoga/MS-Diamonds-Treats.git"
    },

    {
        name: "TasteTrails",
        techStack: ["React Native", "Node.js", "Stripe", "Firebase"],
        description: " A resturant app made with react native. ",
        img: "foodApp.png",
        buttonLink: "/Direction1",
        githubLink: "https://github.com/Promisemagoga/the-restaurant-app.git"
    },
    // {
    //     name: "Air-bnb",
    //     description: " I cloned airbnb to put my reactjs skills in use.",
    //     img: "airbnb-clone.png",
    //     buttonLink: "https://air-bnb-clone-vert.vercel.app/"

    // },
    // {
    //     name: "Untrained Chefs",
    //     description: "are you around jukulyn and feeling like feeding your cravings?Visit untained chefs.Untrained chefs is a local resturant located at soshanguve block K",
    //     img: "untrainedChefs.jpeg",
    //     buttonLink: "https://untrained-chefs.webflow.io/"

    // },
    {
        name: "Shoping-List",
        techStack: ["React Native", "Redux", "Firebase"],
        description: "Making your shopping easy with Shoping-List Application.",
        img: "shopping.png",
        buttonLink: "/Direction2",
        githubLink:"https://github.com/Promisemagoga/React-Shopping-List.git"

    },

    // {
    //     name: "Todo-List software",
    //     description: "Manage your job and study with easy. These todo-list allows you to manage your task according to it's priority.",
    //     img: "todolist.png",
    //     buttonLink: "https://todo-list-app-beta-dun.vercel.app/"

    // },
    // {
    //     name: "Employee-Tracker Software",
    //     description: "Track all the employees in the building",
    //     img: "employee.png",
    //     buttonLink: "https://employee-tracker-app-lyart.vercel.app/"

    // },
]